import { render, staticRenderFns } from "./help.view.vue?vue&type=template&id=c56be07c&scoped=true"
import script from "./help.view.vue?vue&type=script&lang=js"
export * from "./help.view.vue?vue&type=script&lang=js"
import style0 from "./help.view.vue?vue&type=style&index=0&id=c56be07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56be07c",
  null
  
)

export default component.exports